import React from "react";

const FLAGS = {
    ca: {
        label: "Català",
        svg: (
            <svg viewBox="0 0 9 6" className="w-full h-full" aria-hidden="true">
                <rect width="9" height="6" fill="#FCDD09" />
                {[0, 2, 4, 6].map((y) => (
                    <rect key={y} y={y + 0.4} width="9" height="0.66" fill="#DA121A" />
                ))}
            </svg>
        ),
    },
    es: {
        label: "Español",
        svg: (
            <svg viewBox="0 0 3 2" className="w-full h-full" aria-hidden="true">
                <rect width="3" height="2" fill="#C60B1E" />
                <rect y="0.5" width="3" height="1" fill="#FFC400" />
            </svg>
        ),
    },
    en: {
        label: "English",
        svg: (
            <svg viewBox="0 0 60 30" className="w-full h-full" aria-hidden="true">
                <clipPath id="t">
                    <path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z" />
                </clipPath>
                <path d="M0,0 v30 h60 v-30 z" fill="#012169" />
                <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" />
                <path d="M0,0 L60,30 M60,0 L0,30" clipPath="url(#t)" stroke="#C8102E" strokeWidth="4" />
                <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10" />
                <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6" />
            </svg>
        ),
    },
};

export default function LanguageSwitcher({ lang, setLang }) {
    return (
        <div className="flex items-center gap-1.5" data-testid="language-switcher">
            {Object.entries(FLAGS).map(([code, { label, svg }]) => (
                <button
                    key={code}
                    type="button"
                    onClick={() => setLang(code)}
                    aria-label={label}
                    title={label}
                    data-testid={`lang-${code}`}
                    className={`w-8 h-8 rounded-full overflow-hidden border-2 transition-all ${
                        lang === code
                            ? "border-brand-terracotta ring-2 ring-brand-terracotta/30 scale-105"
                            : "border-transparent opacity-60 hover:opacity-100"
                    }`}
                >
                    <div className="w-full h-full overflow-hidden">{svg}</div>
                </button>
            ))}
        </div>
    );
}
